import { LazyRender } from '@packages/modules/src/LazyRender/LazyRender';
import { ErrorBoundary } from '@packages/shared/src/components/ErrorBoundary/ErrorBoundary';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import dynamic from 'next/dynamic';
import type { CmsData } from '../../../interfaces/webapp_json';
import { registerFlexibleComponentsFooter } from '../../components/ComponentRecognizer/registerFlexibleComponentsFooter';
import { AreaSocket } from '../../components/Footer/AreaSocket/AreaSocket';
import { AreaTop } from '../../components/Footer/AreaTop/AreaTop.client';
import { FooterFallbackError } from './FooterFallbackError';
import { FooterFallbackLoading } from './FooterFallbackLoading';

// register the dynamic components
registerFlexibleComponentsFooter();

type PageRendererProps = {
  data: CmsData;
  socketOnly?: boolean;
};

const DynamicBlockContent = dynamic(
  () =>
    import(
      /* webpackChunkName: 'CMS_FooterBlockContent' */ '../../components/Footer/BlockContent/BlockContent.client'
    ).then((mod) => mod.BlockContent),
  {
    ssr: false,
  },
);

const DynamicFooterAccordion = dynamic(
  () =>
    import(/* webpackChunkName: 'CMS_FooterAccordion' */ './FooterAccordion.client').then(
      (mod) => mod.FooterAccordion,
    ),
  {
    ssr: false,
  },
);

export const PageRenderer = ({ data, socketOnly = false }: PageRendererProps) => {
  const { isMobile } = useDeviceType();

  return (
    <>
      {!socketOnly && <AreaTop data={data} />}
      <footer
        className={`bg-color-footer-main text-color-footer-contrasttext [&_button]:text-color-footer-contrasttext [&&_a]:text-color-footer-contrasttext ${socketOnly ? 'mt-[5.75rem]' : 'mt-[3.25rem]'} lg:mt-auto [&_p_a]:hover:underline! lg:[&.footer_block_badges]:flex lg:[&.footer_block_badges]:gap-3 lg:[&>p]:m-0 lg:[&>p+_p]:pt-1`}
      >
        <ErrorBoundary fallback={<FooterFallbackError />}>
          <LazyRender fallback={<FooterFallbackLoading />}>
            {!socketOnly &&
              (isMobile ? (
                <DynamicFooterAccordion data={data} />
              ) : (
                <DynamicBlockContent data={data} />
              ))}
          </LazyRender>
        </ErrorBoundary>
        <AreaSocket data={data} />
      </footer>
    </>
  );
};
